var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import UploadFile from "@/components/dev/upload";
import logger from "js-logger";
import InstalledModuleDisplay from "./installedModuleDisplay";
import { useDeployedModuleMutation, useGetAdminUpgradeWizardQuery, } from "@/store/api";
import StagedModuleDisplay from "./stagedModuleDisplay";
import { LoaderImage } from "@/utils/loader";
/**
 * <b>Page d'administration permettants aux administrateurs d'installer/désinstaller les modules
 */
export default function UpgradeWizard() {
    var _this = this;
    var t = useTranslation(["Administration", "common"]).t; // For translation
    var _a = useState([]), installedModule = _a[0], setInstalledModule = _a[1];
    var _b = useState([]), availableModule = _b[0], setAvailableModule = _b[1];
    var _c = useState(false), isLoad = _c[0], setLoad = _c[1];
    var responseUpgradeWizard = useGetAdminUpgradeWizardQuery({}).data;
    useEffect(function () {
        if (responseUpgradeWizard === null || responseUpgradeWizard === void 0 ? void 0 : responseUpgradeWizard.data) {
            setInstalledModule(responseUpgradeWizard.data.installed);
            setAvailableModule(responseUpgradeWizard.data.available);
        }
    }, [responseUpgradeWizard]);
    var onEntriesDroped = useCallback(function (acceptedFiles) {
        try {
            acceptedFiles.forEach(function (fileEntry) {
                var fileType = [
                    "application/zip",
                    "application/x-zip",
                    "application/x-zip-compressed",
                    "application/octet-stream",
                ];
                if (fileEntry === null || fileEntry === void 0 ? void 0 : fileEntry.file) {
                    if (fileType.includes(fileEntry === null || fileEntry === void 0 ? void 0 : fileEntry.file.type)) {
                        addModule(fileEntry);
                    }
                    else {
                        alert(t("app.LBL_FILE_NOT_ALLOWED"));
                    }
                }
            });
        }
        catch (error) {
            logger.debug("Erreur lors de l'upload");
        }
    }, []);
    var addModuleMutation = useDeployedModuleMutation()[0];
    var addModule = function (file) { return __awaiter(_this, void 0, void 0, function () {
        var response, resp, dat, datas, mes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoad(true);
                    return [4 /*yield*/, addModuleMutation({
                            body: {
                                file: file,
                                remove: false,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    resp = response || {};
                    dat = (resp === null || resp === void 0 ? void 0 : resp.data) || {};
                    datas = (dat === null || dat === void 0 ? void 0 : dat.data) || {};
                    mes = (datas === null || datas === void 0 ? void 0 : datas.message) || "";
                    if (mes === "") {
                        setLoad(false);
                        alert(t("app.LBL_MODULE_INVALID"));
                    }
                    else {
                        setLoad(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "configurator dark:bg-black dark:text-white relative bg-[var(--colors-bg-default)] text-[--colors-label] p-2 space-y-6 m-2 rounded-md", style: { overflowY: "auto" } }, { children: [installedModule &&
                installedModule.map(function (mod) { return (_jsx(InstalledModuleDisplay, { moduleObject: mod })); }), _jsxs("div", __assign({ className: "modules-uploader relative" }, { children: [_jsxs("ul", __assign({ className: "modules-list" }, { children: [_jsx("label", __assign({ className: "flex justify-right items-right ml-4" }, { children: t("app.LBL_DROP_HERE_OR_SELECT", { ns: "common" }) })), _jsx("li", { children: _jsx(UploadFile, { labelUpload: t("LBL_BROWSE", { ns: "Administration" }), type: "file", onEntriesDroped: onEntriesDroped, className: "justify-right ml-4 w-20" }) })] })), isLoad && _jsx(LoaderImage, {}), availableModule &&
                        availableModule.map(function (mod) { return (_jsx(StagedModuleDisplay, { moduleObject: mod })); })] }))] })));
}
